import React from "react";

import { WatchVec2 } from "@piqnt/runtime-core/react/WatchValue";

import {
  useMiddleware,
  EmitFunction,
} from "@piqnt/runtime-core/react/ReactMount";
import { SpaceContext } from "../space";

import { getLabel } from "@piqnt/runtime-core/common/Label";
import { getKey, type PlainBody } from "@piqnt/runtime-space/drawing-model";

interface LiveBodyProps {
  emit: EmitFunction;
  body: PlainBody;
  selected: boolean;
  selectable?: boolean;
  variant?: "short";
}

class LiveBodyComponent extends React.PureComponent<LiveBodyProps> {
  handleClick = () => {
    const { emit, body } = this.props;
    emit("select-body", { body: getKey(body) });
  };

  render() {
    const { body, selected, selectable, variant } = this.props;
    if (!body) {
      return null;
    }
    const label = getLabel(body);

    let showType: boolean;
    let showPosition: boolean;

    if (variant === "short") {
      showType = false;
      showPosition = !label;
    } else {
      showType = true;
      showPosition = true;
    }

    let className = "";
    className += selected ? "selected-item " : "";
    className += selectable ? "clickable " : "";
    return (
      <span
        className={className}
        onClick={selectable ? this.handleClick : null}
      >
        {label ? "body#" + label : showType && body.type}{" "}
        {showPosition && <WatchVec2 getValue={() => body.position} />}
      </span>
    );
  }
}

interface LiveBodyComponentProps {
  body: PlainBody;
  selectable?: boolean;
  variant?: "short";
}

export const LiveBody = (props: LiveBodyComponentProps) => {
  const { context, emit } = useMiddleware<SpaceContext>();
  const bodyKey = getKey(props.body);
  const selected = !!context.multiselect.value.findKey(bodyKey);

  return (
    <LiveBodyComponent
      body={props.body}
      selectable={props.selectable}
      variant={props.variant}
      emit={emit}
      selected={selected}
    />
  );
};
